import * as images from "../Images";

export default function index() {
  return (
    <div className="justify-content-center align-items-center vh-100 vw-100 d-flex">
      <img src={images.error404} className="img-fluid mt-4" alt="" />
    </div>
  );
}
